import React, {useEffect, useState} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faChevronRight} from "@fortawesome/free-solid-svg-icons";
import useEodClosing from "../../api/EODClosing";
import {formatAccount, formatAccountRev} from "../../features/ValueFormater";
import UtcToLocal from "../UtcToLocal";

function EodDetails({visible, setVisible, activeRowIndex, setActiveRowIdex}) {
    const [nextButtonDisabled, setNextButtonDisabled] = useState(true);
    const [prevButtonDisabled, setPrevButtonDisabled] = useState(true);
    const [transactionId, setTransactionId] = useState(null);
    const {
        GetEODClosingTrxDetails, trxDetails, detailsLoading
    } = useEodClosing();

    useEffect(() => {
        if (activeRowIndex) {
            GetEODClosingTrxDetails(activeRowIndex);
            setTransactionId(activeRowIndex);
        }
    }, [activeRowIndex]);

    useEffect(() => {
        setPrevButtonDisabled(trxDetails?.PreviousTransactionID === 0)
        setNextButtonDisabled(trxDetails?.NextTransactionID === 0)
    }, [trxDetails])

    const currencyId = trxDetails?.CurrencyID || 0;
    const currency = trxDetails?.CurrencyID === 1 ? '$' : 'LL'

    const handleNavigation = (tranId) => {
        if (tranId !== 0) {
            GetEODClosingTrxDetails(tranId);
            setTransactionId(tranId)
        }else{
            setActiveRowIdex(false);
            setVisible(false);
        }
    }

    const options = {
        weekday: 'short', day: 'numeric', month: 'short', year: 'numeric'
    };

    return (<>
            {(visible && activeRowIndex) && <>
                <div className="switch">
                    <div className="goBackCont">
                        <button
                            className="goBack"
                            // disabled={prevButtonDisabled}
                            onClick={() => {
                                handleNavigation(trxDetails.PreviousTransactionID);
                            }}
                        >
                            <FontAwesomeIcon icon={faChevronLeft}/>
                        </button>
                        <div className="transactionId">Transaction N <span>{transactionId}</span>
                        </div>
                    </div>
                    <button
                        className="goNext"
                        // disabled={nextButtonDisabled}
                        onClick={() => {
                            handleNavigation(trxDetails.NextTransactionID);
                        }}
                    ><FontAwesomeIcon icon={faChevronRight}/></button>
                </div>

                <div className="TransactionContainer">

                    <div className="headerContainer">
                        {(trxDetails?.FromDate && trxDetails?.ToDate) && <div className="date">
                            <UtcToLocal utcTimestamp={trxDetails.FromDate} options={options}/>
                            <div className="mx-2">to</div>
                            <UtcToLocal utcTimestamp={trxDetails.ToDate} options={options}/>
                        </div>}

                        <table className="table0">
                            <thead>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Initial Amount ({currency})</td>
                                <td>Discounted Amount ({currency})</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>TOTAL</td>
                                <td></td>
                                <td></td>
                                <td>{formatAccount(trxDetails?.TotalInitialAmount || 0, trxDetails?.CurrencyID || 0)}</td>
                                <td>
                                    <span>{formatAccount(trxDetails?.TotalDiscountedAmount || 0, trxDetails?.CurrencyID || 0)}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <table className="table1">
                            <thead>
                            <tr>
                                <td>Branches</td>
                                <td>Tills</td>
                                <td>N Transactions</td>
                                <td>Initial Amount (currency)</td>
                                <td>Discounted Amount (currency)</td>
                            </tr>
                            </thead>
                        </table>
                        {trxDetails?.TransactionsPerBranches.map((branchDetails) => {
                            return (<>
                                <table className="table2">
                                    <thead>
                                    <tr>
                                        <td><span>{branchDetails?.BranchName}</span></td>
                                        <td></td>
                                        <td><span>{branchDetails?.BranchNumOfTransactions}</span></td>
                                        <td>{formatAccountRev(branchDetails?.BranchInitialAmount, currencyId)}</td>
                                        <td>
                                            <span>{formatAccountRev(branchDetails?.BranchDiscountedAmount, currencyId)}</span>
                                        </td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {branchDetails?.TransactionsPerBranchTills.map((tillDetails) => (<>
                                            <tr>
                                                <th></th>
                                                <td>{tillDetails?.TillName}</td>
                                                <td>{tillDetails?.TillNumOfTransactions}</td>
                                                <td>{formatAccountRev(tillDetails?.TillInitialAmount, currencyId)}</td>
                                                <td>
                                                    <span>{formatAccountRev(tillDetails?.TillDiscountedAmount, currencyId)}</span>
                                                </td>
                                            </tr>
                                        </>))}
                                    </tbody>
                                </table>
                            </>)
                        })}
                    </div>
                </div>
            </>}
        </>);
}

export default EodDetails;
